/* eslint-disable no-undef */
import { useEffect, useRef, useState } from 'react';

export const useWindowSize = () => {
    const [height, setHeight] = useState(window.innerHeight);
    const [width, setWidth] = useState(window.innerWidth);

    const timeout = useRef<NodeJS.Timeout>();

    const onWindowSizeChange = () => {
        clearTimeout(timeout.current);
        timeout.current = setTimeout(() => {
            setHeight(window.innerHeight);
            setWidth(window.innerWidth);
        }, 100);
    };

    useEffect(() => {
        window.addEventListener('resize', onWindowSizeChange);
        return () => {
            window.removeEventListener('resize', onWindowSizeChange);
        };
    }, []);

    return {
        height,
        width,
    };
};
